import React from 'react';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/3nn9fjmCSFpNpxusU3Kycj/azcitypac_logo-wht.png';
interface LogoProps {
  className?: string;
}

/**
 * The reversed (white and gold) AZ City PAC lockup, intended for the navy
 * chrome in the header and footer.
 */
export function Logo({
  className = 'h-12'
}: LogoProps) {
  return <img src={LOGO_URL} alt="AZ City PAC — Strong Cities. Stronger Arizona." className={`w-auto object-contain ${className}`} data-id="element-196" data-mp="3v8xq7q3kqls4" />;
}